import { useFormContext } from "react-hook-form";
import { type FormSectionText_Fields } from "~/__generated__/graphql";

export default function Text({
  label,
  placeholder,
  required,
  type,
}: FormSectionText_Fields & {
  type?: string;
}) {
  const { register } = useFormContext();

  return (
    <div className="space-y-2">
      <label htmlFor={label!} className="mb-2 text-lg font-medium text-white">
        {label}
      </label>
      <input
        {...register(label!, { required: required ?? false })}
        placeholder={
          placeholder ? (required ? `${placeholder}*` : placeholder) : ""
        }
        required={required ?? false}
        type={type}
        className="h-15 w-full rounded-sm border border-white bg-black px-7 py-3 text-lg font-normal leading-relaxed text-white placeholder-white focus-visible:outline-none"
      />
    </div>
  );
}
